import { Title, Section } from "@vshp/ui-components";
import Slider from "../utils/Slider";
import { Image } from "antd";

import certificatesPicture1 from "../../../public/images/certificates/certificates_01.png";
import certificatesPicture2 from "../../../public/images/certificates/certificates_02.png";
import certificatesPicture3 from "../../../public/images/certificates/certificates_03.png";
import certificatesPicture4 from "../../../public/images/certificates/certificates_04.png";

const certificates = [
  {
    src: certificatesPicture1.src,
  },
  {
    src: certificatesPicture2.src,
  },
  {
    src: certificatesPicture3.src,
  },
  {
    src: certificatesPicture4.src,
  },
];

const Certificates = () => {
  const settings = {
    infinite: true,
  };

  return (
    <Section border={true}>
      <Title type="h2">Документы об образовании</Title>
      <div className="wysiwyg">
        <p>
          По&nbsp;окончании 9-ти классов ребёнок получит аттестат об&nbsp;основном общем образовании.
          <br />
          Выпускники 11-го класса&nbsp;&mdash; аттестат о&nbsp;среднем общем образовании.
        </p>
      </div>
      <div className="slider-certificates">
        <Slider className="slider__dots_accent" sliderSettings={settings}>
          {certificates.map((item, key) => (
            <div className="slider__item" key={key}>
              <div className="slider-certificates__item">
                <div className="slider-certificates__img-wrap">
                  <Image src={item.src} alt="Документ" />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Section>
  );
};

export default Certificates;
